import RelativeTime from 'components/common/RelativeTime';
import RepairOrderActivity from 'models/RepairOrderActivity';
import React from 'react';
import { connect } from 'react-redux';

interface Props {
    activityLogs: RepairOrderActivity[];
}

const RepairOrderActivityLog: React.FC<Props> = ({ activityLogs }: Props) => {
    return (
        <div className="space-y-3">
            {!!activityLogs &&
                activityLogs?.map((log) => {
                    return (
                        <div className="flex item" key={log.id}>
                            <div className="w-2 h-2 rounded-full bg-blue-500 mt-2 mr-3"></div>
                            <div className="">
                                <p className="font-semibold">{log.description}</p>
                                <p className="text-sm text-gray-500">
                                    <RelativeTime dateTime={log.activityDate} floatRight={false} />
                                </p>
                            </div>
                        </div>
                    );
                })}
        </div>
    );
};

const mapStateToProps = (state: any) => ({
    activityLogs: state.repairOrder.activityLogs,
});

export default connect(mapStateToProps)(RepairOrderActivityLog);
